import React from 'react';
import { Alert } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useUserData } from '../contexts/UserDataContext';

const AdminWarningBanner = React.memo(() => {
  const { userProfile, orgInfo } = useUserData();

  // Only show banner for admin users
  if (userProfile?.app_role !== 'admin') {
    return null;
  }

  const orgName = orgInfo?.company || 'ORGANIZATION';

  return (
    <Alert
      message={
        <span>
          <WarningOutlined style={{ marginRight: 8 }} />
          <strong>ADMIN ACCOUNT for {orgName}</strong> - CONSULT WITH CLIENT BEFORE MAKING CHANGES
        </span>
      }
      type="warning"
      banner
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
        textAlign: 'center',
        fontWeight: 'bold',
        borderRadius: 0
      }}
    />
  );
});

AdminWarningBanner.displayName = 'AdminWarningBanner';

export default AdminWarningBanner;
